<template>
  <div>
    <div class="ui huge borderless menu">
      <a href="#" class="item" @click.prevent="triggerMenu">
        <i class="content icon"></i>
      </a>
      <div class="item" style="font-weight: 300">
        Selected date:
      </div>
      <a href="#" class="item" @click.prevent="dateMinus"><i class="icon arrow left"></i></a>
      <div class="calendar item">
        <div class="ui basic calendar">
          <div class="ui huge icon input">
            <i class="calendar icon"></i>
            <input type="text" name="date" placeholder="Datum">
          </div>
        </div>
      </div>
      <a href="#" class="item" @click.prevent="datePlus"><i class="icon arrow right"></i></a>
      <div class="item">
        <i class="circle notched loading icon" v-if="loading"></i>
      </div>
      <div class="right menu"></div>
      <!--<div class="item">-->
        <!--Daily Income: <div class="ui blue basic large label">€{{ numeral(dailyReport.income).format('0,0.00') }}</div>-->
      <!--</div>-->
      <a href="#" class="small add-reservation item" @click.prevent="startCreateReservation"><i class="plus icon"></i> Add Reservation</a>
    </div>
    <div class="ui segment" id="segment" style="position: relative; margin-bottom: 30px;">
      <h4 class="ui red header">
        Buchungsbeginn zur vollen Stunde
      </h4>
      <table class="ui definition celled bottom attached fifteen column table">
        <thead>
        <tr>
          <th class="two wide"></th>
          <th v-for="hour in hours" class="center aligned"
              :id="hour == '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)">
            {{ hour }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="boat in boatsStartFull"
            :class="{ 'thick-border': boats[boats.indexOf(boat) - 1] && boat.type !== boats[boats.indexOf(boat) - 1].type }"
            :key="boat._id">
          <td class="center aligned boat-title" :class="{ 'out': boat.state.currentlyOut }">
            <span class="title" :class="{ 'hidden': boat.hidden }">
              {{ boat.name }} <i class="hide icon" v-if="boat.hidden"></i>
            </span>
            <span v-if="boat.state.currentlyOut" style="font-size: 12px; color: #c54700"><br>IN USE <i
                class="circle notched loading icon" v-if="boat.state.currentlyOut"></i></span>
          </td>
          <booking-choice v-for="(hour, index) in hours"
                          :hour="hour" :hourIndex="index" :boat="boat" :hours="hours"
                          :key="boat._id+'-'+hour.index" :selected="selected"
                          :date="date" @selected="selected" :id="boat._id+'-'+index"
                          :move="move" :create="create" :settings="settings"
                          :updatedBooking="updatedBooking"
                          :allBookings="allBookings"
                          @triggerDetails="openReservationDetails"
                          @moveBooking="moveBooking"
                          @moveTo="moveTo"
                          @selectForCreate="selectForCreate"></booking-choice>
        </tr>
        </tbody>
      </table>
      <div
          :style="{ width: '2px', height: '100%', position: 'absolute', backgroundColor: 'red', top: '0px', left: ruler.left }"
          v-if="ruler.visible"></div>
    </div>
    <div class="ui segment" id="segment2" style="position: relative; margin-bottom: 120px;">
      <h4 class="ui red header">
        Buchungsbeginn zur halben Stunde
      </h4>
      <table class="ui definition celled bottom attached table" style="width: auto">
        <thead>
        <tr>
          <th class="two wide" style="width: 119px !important"></th>
          <th v-for="hour in hours" class="center aligned" style="width: 86px !important;"
              :id="hour == '10 - 11' ? 'firstHourHeader' : (hour == '22 - 23' ? 'lastHourHeader' : false)">
            {{ (parseInt(hour.split(' - ')[0]) - 1) + ':30' }}<br>-<br>{{ (parseInt(hour.split(' - ')[1]) - 1) + ':30' }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="boat in boatsStartHalf"
            :class="{ 'thick-border': boats[boats.indexOf(boat) - 1] && boat.type !== boats[boats.indexOf(boat) - 1].type }"
            :key="boat._id">
          <td class="center aligned boat-title" :class="{ 'out': boat.state.currentlyOut }">
            <div class="title" :class="{ 'hidden': boat.hidden }" style="width: 105px">
              {{ boat.name }} <i class="hide icon" v-if="boat.hidden"></i>
            </div>
            <div v-if="boat.state.currentlyOut" style="font-size: 12px; color: #c54700">IN USE <i
              class="circle notched loading icon" v-if="boat.state.currentlyOut"></i></div>
          </td>
          <booking-choice v-for="(hour, index) in hours"
                          :hour="hour" :hourIndex="index" :boat="boat" :hours="hours"
                          :key="boat._id+'-'+hour.index" :selected="selected"
                          :date="date" @selected="selected" :id="boat._id+'-'+index"
                          :move="move" :create="create" :settings="settings"
                          :updatedBooking="updatedBooking"
                          :allBookings="allBookings"
                          @triggerDetails="openReservationDetails"
                          @moveBooking="moveBooking"
                          @moveTo="moveTo"
                          @selectForCreate="selectForCreate"></booking-choice>
        </tr>
        </tbody>
      </table>
      <div
        :style="{ width: '2px', height: '100%', position: 'absolute', backgroundColor: 'red', top: '0px', left: ruler.left }"
        v-if="ruler.visible"></div>
    </div>
    <div class="bottom-message" v-if="move.status">
      <div class="ui icon floating message">
        <i class="notched circle loading icon"></i>
        <div class="content">
          <div class="header">
            Select the slot to move the reservation to
          </div>
          <p>You are moving the reservation <strong>{{ move.booking.reservation.code }}</strong>
            from <strong>{{ move.booking.date }}</strong>, boat <strong>{{ move.booking.boat.name }}</strong>
            at <strong>{{ move.booking.hour }}h</strong></p>
          <div class="ui negative tiny button" @click="move.status = false">Cancel moving</div>
        </div>
      </div>
    </div>
    <div class="bottom-message" v-if="create.status">
      <div class="ui icon floating message">
        <i class="notched circle loading icon"></i>
        <div class="content">
          <div class="header">
            Select slots to create reservation for
          </div>
          <p>Please select the slots to book for the new reservation.</p>
          <div class="ui positive tiny button" @click="showNewReservationModal" v-if="create.selected.length > 0"><i class="checkmark icon"></i> Create Reservation</div>
          <div class="ui negative basic tiny button" @click="create.status = false; create.selected = []"><i class="close icon"></i> Cancel</div>
        </div>
      </div>
    </div>
    <details-modal :reservationProp="editReservation" :boats="boats"></details-modal>
    <new-reservation-modal :selected="create.selected" @reservationCreated="create.status = false; create.selected = []"></new-reservation-modal>
  </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../services/'
  import BookingChoice from './BookingChoice.vue'
  import DetailsModal from './reservations/DetailsModal.vue'
  import NewReservationModal from './NewReservationModal.vue'
  import '../../../bower_components/semantic-ui-calendar/dist/calendar.min'
  import '../../../bower_components/semantic-ui-calendar/dist/calendar.min.css'

  export default {
    data() {
      return {
        'date': null,
        'loading': false,
        'allBookings': [],
        'selected': [],
        'hours': [
          '10 - 11', '11 - 12', '12 - 13', '13 - 14', '14 - 15', '15 - 16', '16 - 17', '17 - 18', '18 - 19', '19 - 20', '20 - 21', '21 - 22', '22 - 23'
        ],
        'boats': [],
        'move': {
          'status': false,
          'booking': null
        },
        'create': {
          'status': false,
          'selectedDone': false,
          'selected': []
        },
        'editReservation': null,
        'settings': {},
        'now': new Date(),
//        'ruler': {
//          'visible': false,
//          'left': '0px',
//        },
        'rulerGeometry': {
          'span': 50,
          'leftOffset': 0
        },
        'dailyReport': {
          'date': null,
          'income': 0,
        },
        'searchInProgress': 0,
        'updatedBooking': null,
        'numeral': numeral
      }
    },
    mounted() {
      this.fetchBoats()

      setInterval(() => {
        this.now = moment().format()
      }, 60 * 1000)

      services.settingService.find({
        $limit: 1,
        $sort: {_id: -1}
      }).then(settings => {
        console.log(settings)
        if (settings.total > 0) this.settings = settings.data[0]
      })

      moment.locale('de')

      const formatter = {
        date: (date, settings) => {
          return moment(date).format('dddd, LL')
        }
      }

      services.boatService.on('patched', boat => {
        let updated = this.boats.filter((filterBoat) => {
          return filterBoat._id === boat._id
        })

        if (updated.length > 0) this.boats.splice(this.boats.indexOf(updated[0]), 1, boat)
      })

      $('.huge.menu').visibility({
        type: 'fixed',
        offset: 0
      });

      $('.ui.basic.calendar').calendar({
        type: 'date',
        initialDate: new Date(),
        formatter: formatter,
        text: {
          months: ['Januar', 'Februar', 'März', 'April', 'May', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
          today: 'Heute',
          now: 'Jetzt'
        },
        onChange: (date, text) => {
          this.date = moment(date).format('YYYY-MM-DD')
        }
      }).calendar('set date', new Date())

      this.setUpEvents()

      this.getGeometry()
    },
    watch: {
      date: _.debounce(function () {
        this.loading = true
        services.bookingService.find({
          query: {
            date: this.date,
            $limit: 500
          }
        }).then(bookings => {
          this.loading = false

          this.allBookings = bookings.data
        }).catch(error => {
          this.loading = false
          toastr.error('There was an error loading bookings, please try again!', 'Error')
        })
      }, 200)
    },
    computed: {
      ruler() {
        if (this.date != moment().format('YYYY-MM-DD')) {
          return {
            'visible': false,
            'left': '0px'
          }
        }

        console.log('calculating ruler...')

        let firstTime = moment().hours(10).minutes(0).seconds(0)
        let diffSeconds = moment(this.now).diff(firstTime, 'seconds')
        let left = 0

        if (diffSeconds > 0 && diffSeconds <= 13 * 60 * 60) {
          left = Math.round(this.rulerGeometry.leftOffset + (diffSeconds / (13 * 60 * 60)) * this.rulerGeometry.span)
        } else {
          return {
            'visible': false,
            'left': '0px'
          }
        }

        return {
          'visible': true,
          'left': left + 'px'
        }
      },
      boatsStartFull() {
        return this.boats.filter(b => !b.startsAtHalfHour)
      },
      boatsStartHalf() {
        return this.boats.filter(b => !!b.startsAtHalfHour)
      }
    },
    beforeDestroy() {
      $('.ui.modals').remove()
      services.bookingService.removeListener('created')
      services.bookingService.removeListener('patched')
      services.bookingService.removeListener('removed')
      services.boatService.removeListener('patched')
    },
    methods: {
      setUpEvents() {

        services.bookingService.on('created', booking => {
          this.updatedBooking = booking

          if (booking.status !== 'open' && this.create.selected.filter(b => {return b._id === booking._id}).length > 0) {
            toastr.error('Someone has just selected the same booking slot.', 'Clearing selection!')
            this.create.selected = []
            $('#newReservationModal').modal('hide')
          }
        })

        services.bookingService.on('patched', booking => {
          this.updatedBooking = booking

          if (booking.status !== 'open' && this.create.selected.filter(b => {return b._id === booking._id}).length > 0) {
            toastr.error('Someone has just selected the same booking slot.', 'Clearing selection!')
            this.create.selected = []
            $('#newReservationModal').modal('hide')
          }
        })

        services.bookingService.on('removed', booking => {
        })

        services.reservationService.on('patched', reservation => {
          if (this.editReservation && this.editReservation._id === reservation._id) this.editReservation = reservation
        })
      },
      getGeometry() {
        setTimeout(() => {
          let firstHourHeader = document.getElementById('firstHourHeader').getBoundingClientRect()
          let lastHourHeader = document.getElementById('lastHourHeader').getBoundingClientRect()
          let container = document.getElementById('segment').getBoundingClientRect()

          let offsetFirst = firstHourHeader.left - container.left
          let offsetLast = lastHourHeader.right - container.left

          this.rulerGeometry.span = offsetLast - offsetFirst
          this.rulerGeometry.leftOffset = offsetFirst
        }, 500)
      },
      fetchBoats() {
        services.boatService.find({query: {$sort: {'order': 1}, $limit: 200}}).then((boats) => {
          this.boats = boats.data
          this.initDropdown()
        })
      },
      datePlus() {
        $('.ui.basic.calendar').calendar('set date', moment(this.date).add(1, 'd').format())
      },
      dateMinus() {
        $('.ui.basic.calendar').calendar('set date', moment(this.date).subtract(1, 'd').format())
      },
      initDropdown() {
        setTimeout(() => {
          $('.ui.dropdown').dropdown()
        }, 50)
      },
      selected(booking) {
        this.selected.push(booking)
      },
      moveBooking(booking) {
        console.log('receiving move booking', booking)
        this.move.status = true
        this.move.booking = booking
      },
      moveTo(booking) {

        if (booking._id) {

          console.log('patching old object')

          services.bookingService.patch(booking._id, {
            '_reservation': this.move.booking._reservation,
            'status': this.move.booking.status
          }).then(newBooking => {
            return services.bookingService.patch(this.move.booking._id, {
              '_reservation': null,
              'discardedReservation': this.move.booking.reservation,
              'status': 'open'
            })
          }).then(oldBooking => {
            toastr.success('Move completed!')
            this.move.status = false
            this.move.booking = null
          })
        } else {
          let bookingDocument = {
            '_boat': booking._boat,
            'hour': booking.hour,
            'date': booking.date,
            'cost': booking.boat.price,
            '_reservation': this.move.booking._reservation,
            'status': this.move.booking.status
          }

          console.log('creating new object', bookingDocument)

          services.bookingService.create(bookingDocument).then(newBooking => {
            console.log(newBooking)
            return services.bookingService.patch(this.move.booking._id, {
              '_reservation': null,
              'discardedReservation': this.move.booking.reservation,
              'status': 'open'
            })
          }).then(oldBooking => {
            toastr.success('Move completed!')
            this.move.status = false
            this.move.booking = null
          })
        }
      },
      selectForCreate(booking) {
        if (!booking._id) return

        let index = this.create.selected.findIndex(selectedBooking => { return selectedBooking._id === booking._id })

        if (index !== -1) this.create.selected.splice(index, 1)
        else this.create.selected.push(booking)
      },
      startCreateReservation() {
        this.create.status = true
      },
      showNewReservationModal() {
        $('#newReservationModal').modal('show')
        setTimeout(() => {
          $('#newReservationModal').modal('refresh')
        }, 50)
      },
      triggerMenu() {
        $('.ui.sidebar').sidebar('toggle')
      },
      openReservationDetails(reservation) {
        console.log('open reservation')
        this.editReservation = reservation
        $('#reservationModal').modal('show')
      }
    },
    components: {
      BookingChoice, DetailsModal, NewReservationModal
    }
  }
</script>

<style scoped>
  .ui.calendar input {
    border: none;
    font-size: 1.3rem;
  }

  .calendar.item {
    padding: 4px 1px 0;
  }

  .boat-title {
    cursor: pointer;
  }

  .boat-title.out {
    background-color: #ffd1a4 !important;
  }

  .boat-title .title {
    color: #4183C4;
  }

  .boat-title .title.hidden {
    color: #b4b4b4;
  }

  .huge.menu.placeholder {
    height: 43px;
  }

  td.boat-title:hover {
    background: rgba(0, 0, 0, .1) !important;
  }

  tr.thick-border td {
    border-top: 2px solid rgba(0, 0, 0, 0.4);
  }

  .red {
    color: #ea0011;
  }

  .small.add-reservation.item {
    font-size: 14px;
    color: #771d14;
  }

  .bottom-message {
    position: fixed;
    bottom: 20px;
    max-width: 80%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.75;
  }

  .calendar .huge.input {
    width: 325px;
  }
</style>



// WEBPACK FOOTER //
// Booking.vue?53c06cbd